import * as React from 'react'
import { useState } from 'react'
import { Button, mergeClasses, Text } from '@fluentui/react-components'
import { FileStatus, IOverviewItemDto } from '../../config/fileConfig'
import FormattedDateTime from '../../components/Date/FormattedDateTime'
import PersonAvatar from '../../components/PersonAvatar'
import { BaseOverviewLineItemProps, useOverviewStyles } from '../BaseOverview/BaseOverview'
import { FileFilterType, FileSortingType } from './FileOverview'
import { PinColor, PinRegular } from '@fluentui/react-icons'
import useAxios from '../../hooks/useAxios'
import { Link } from 'react-router-dom'

export function FileListItem(props: BaseOverviewLineItemProps<IOverviewItemDto, FileFilterType, FileSortingType>) {
    const axios = useAxios()
    const overviewStyles = useOverviewStyles()

    const [pinned, setPinned] = useState<boolean>(props.item.pinned === true)

    return (
        <>
            <PersonAvatar name={props.item.owner.fullName} color={'colorful'} size={24} />
            <Link
                to={`/file/${props.item.id}`}
                className={mergeClasses(props.viewportLarge && overviewStyles.gridSpan2Columns)}
                data-type={props.item.status === FileStatus.Archived ? 'strikethrough' : 'open'}
            >
                {props.item.name}
            </Link>
            <Button
                size={'small'}
                appearance={'subtle'}
                data-hover-actions={!pinned}
                icon={pinned ? <PinColor /> : <PinRegular />}
                onClick={e => {
                    e.preventDefault()
                    axios
                        .post(`/file/${props.item.id}/pin`, `${!pinned}`, {
                            headers: { 'Content-Type': 'text/plain' },
                        })
                        .then(() => {
                            setPinned(!pinned)
                            props.onUpdateItem(props.item)
                        })
                }}
            />
            <Link to={`/file/${props.item.id}`} data-type={props.item.status === FileStatus.Archived ? 'strikethrough' : 'open'}>
                <Text size={200}>{props.item.reference}</Text>
            </Link>
            <div className={overviewStyles.alignEnd}>{props.item.lastAccess && <FormattedDateTime date={props.item.lastAccess} />}</div>
        </>
    )
}
